// import { maybeOptInToNextLayer } from '#core/utils/next-layers'

// Please read apps/docs/src/platform/feature-flags.md before using this feature.
export default defineNuxtPlugin({
  name: 'next-layers-core',
  dependsOn: ['auth'],
  async setup() {
    // maybeOptInToNextLayer({
    //   featureFlag: 'your-feature-flag',
    //   paths: ['leaderboards'],
    // })
  },
})
